/**
 * @generated SignedSource<<4108c2a60764fc9335d4561c171e86a1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "serviceId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "serviceId"
      }
    ],
    "concreteType": "Service",
    "kind": "LinkedField",
    "name": "serviceById",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Addl",
        "kind": "LinkedField",
        "name": "addls",
        "plural": true,
        "selections": [
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "checkOutCreateServiceByIdQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "checkOutCreateServiceByIdQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "0be337bcbeeaee7bd5e4d9096903f9cf",
    "id": null,
    "metadata": {},
    "name": "checkOutCreateServiceByIdQuery",
    "operationKind": "query",
    "text": "query checkOutCreateServiceByIdQuery(\n  $serviceId: String\n) {\n  serviceById(id: $serviceId) {\n    id\n    addls {\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "1b4b620c102dd9e62d7b16bf38a6cd98";

module.exports = node;
